/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Desc_AgentsInputs */



/**
* | output |
* | --- |
* | "Deploy customer-side daemons that reach into your internal network (LDAP, SMB shares) on oneAI's behalf." |
*
* @param {Plan_Gate_Desc_AgentsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_desc_agents = /** @type {((inputs?: Plan_Gate_Desc_AgentsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Desc_AgentsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Stellen Sie kundenseitige Daemons bereit, die im Auftrag von oneAI auf Ihr internes Netzwerk zugreifen (LDAP, SMB-Freigaben).")
	return /** @type {LocalizedString} */ ("Deploy customer-side daemons that reach into your internal network (LDAP, SMB shares) on oneAI's behalf.")
});